import React from 'react'

import { AnalyticsExternalSourceIcon } from '../../../../analyticsModule/components/AnalyticsExternalSourceIcon/AnalyticsExternalSourceIcon'
import type { AnalyticsExternalSource } from '../../../../analyticsModule/types'
import { analyticsDecoratorLabelsMap } from '../../../../consts'
import type { AnalyticsDecorator } from '../../../../types'
import * as S from './ReportName.styled'

type ReportNameProps = {
  name: string
  externalSource?: AnalyticsExternalSource
  decorator?: AnalyticsDecorator
}

export const ReportName = ({ name, externalSource, decorator }: ReportNameProps) => {
  return (
    <S.Container>
      {name}
      <AnalyticsExternalSourceIcon externalSource={externalSource} />
      {decorator && <S.DecoratorLabel>{analyticsDecoratorLabelsMap[decorator]}</S.DecoratorLabel>}
    </S.Container>
  )
}
